<template>
    <div class="view-container">

        <div class="position-relative w-100">
            <div class="booking-list-message illustration-new" :class="{ 'active' : hasActiveSearch && clinics.length === 0 }">
                <img src="/images/card/search-message-illustration-new2.svg?d=20211103"
                     :class="{ 'anim' : hasActiveSearch && clinics.length === 0 }">
                <div>Inget resultat, försök igen.</div>
            </div>

            <div class="booking-list-message illustration-new"
                 :class="{ 'active' : !hasActiveSearch && clinics.length === 0 }">
                <img src="/images/card/search-message-illustration-new1.svg?d=20211103">
                <div v-if="app_version !== 'customer_card'">Sök och boka massage på fler än 500 mottagningar runtom i Sverige
                </div>
                <div v-else>
                    <span v-if="filters.product_area === 2">Sök personliga tränare i fältet ovan.</span>
                    <span v-else>Sök och boka massage på fler än 500 mottagningar runtom i Sverige - oavsett var du beställt
                    klippkortet.</span>
                </div>
            </div>
        </div>

        <div class="booking-list-item"
             :key="'lclinic'+clinic.id"
             v-for="clinic in clinics"
             v-if="hasActiveSearch"
             @click="openClinic(clinic.id)"
        >
            <div class="container-fluid">
                <div class="d-flex">
                    <div>
                        <div class="portrait-wrapper">
                            <img :src="clinic.portrait.thumb_url" class="portrait" v-if="clinic.portrait" />
                        </div>
                    </div>
                    <div class="pt-1">
                        <h4 class="mb-1">{{ clinic.card_name_clinic }}</h4>
                        <div>
                            <span v-if="clinic.survey_count > 2 && clinic.show_survey_score === 1" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                            <span v-if="clinic.isNewCached" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                            <span style="color:#333;"><span v-if="clinic.address.co">{{ clinic.address.co }}, </span>{{ clinic.address.street }}, {{ clinic.address.city }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-100" style="height: 74px;" v-if="hasActiveSearch && clinics.length"></div>

    </div>
</template>

<script>

export default {

    props: {
        clinics: {
            required: true
        },
        loading: {
            default: false
        },
        hasActiveSearch: {
            default: false
        },
        filters: {
            required: true
        }
    },

    data () {
        return {
        }
    },

    methods: {
        openClinic (clinic_id) {
            this.matomoTrackEvent('Booking', 'Open clinic', 'List')

            this.$router.push({ name: 'modal-clinic', params: { clinic: clinic_id } })
        }
    }
}
</script>
